module.exports = __webpack_public_path__ + "static/media/Cool.dd3f4030.svg";